import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Categorias from '../views/Categorias.vue'
import Checkout from '../views/Checkout.vue'
import PageNotFound from '../views/PageNotFound.vue'
import Tiendas from '../views/Tiendas.vue'
import isMobile from '../helpers/isMobile'
import ErrorPage from '../views/ErrorPage.vue'
import Franquicias from '../views/Franquicias.vue'
import ProductosMobile from '../views/ProductosListMobile.vue'
import store from '@/store/index'
import validateClient from '../helpers/validarCliente'
import actualizarPedido from '../helpers/actualizarPedido'
import Producto from '../views/Producto.vue'
import EstadoPedido from '../views/EstadoPedido.vue'
import MesaQR from '../views/MesaQR.vue'
import MercadoPagoRedirect from '../views/MercadoPagoRedirect.vue'
import Cuenta from '../views/Cuenta.vue'
import MisPedidos from '../views/MisPedidos.vue'
import { applyPageSeo, applyStoreSeo, storeCanonicalPath } from '@/helpers/seoHelper.js'

Vue.use(VueRouter)

function applyStoreTitleFromState (clientCode) {
  const appData = store.state.App && store.state.App.data
  const logo = store.state.App && store.state.App.logo
  // setDataClient ya aplicó SEO; reforzar canonical /tienda/:client
  if (appData && appData.SEO) {
    applyStoreSeo({
      seo: appData.SEO,
      name: appData.Name,
      clientCode,
      image: logo || undefined
    })
  } else if (appData && appData.Name) {
    applyStoreSeo({
      name: appData.Name,
      clientCode,
      image: logo || undefined
    })
  } else if (clientCode) {
    const path = storeCanonicalPath(clientCode)
    if (path) applyPageSeo({ url: path })
  }
}

const routes = [
  {
    path: '/',
    name: 'Info',
    beforeEnter (to, from, next) {
      if (!isMobile()) window.location.href = 'https://info.clickaway.app/'
      if (process.env.VUE_APP_LISTAR_FRANQUICIAS === 'TRUE') {
        next({
          name: 'Sucursales',
          params: {
            id: process.env.VUE_APP_FRANQUICIA
          }
        })
      } else {
        next({ name: 'Tiendas' })
      }
    }
  },
  {
    path: '/tienda/:client',
    name: 'Home',
    component: Home,
    beforeEnter: async (to, from, next) => {
      const code = to.params.client
      const { Status } = await validateClient(to.params.client)
      if (Status === 'ok' || Status === 'cerrado') {
        await store.dispatch('App/setAppLogo', code)
        await store.dispatch('App/setDataClient', code)
        store.dispatch('App/setAppPreviousPage', from.name)
        // limpiar cache de productos/categorías al cambiar de tienda
        store.commit('Productos/setProducts', [])
        store.commit('Categorias/setCategoria', null)
        applyStoreTitleFromState(code)
      } else {
        next({ name: 'PageNotFound' })
      }
      next()
    }
  },
  {
    path: '/tienda/:client/mis-pedidos',
    name: 'MisPedidos',
    component: MisPedidos,
    beforeEnter: async (to, from, next) => {
      const code = to.params.client
      try {
        const { Status } = await validateClient(code)
        if (Status === 'ok' || Status === 'cerrado') {
          store.dispatch('App/setAppLogo', code)
          await store.dispatch('App/setDataClient', code)
          {
            const appData = store.state.App && store.state.App.data
            applyPageSeo({
              title: (appData && appData.Name) ? `Mis pedidos - ${appData.Name}` : 'Mis pedidos - Click Away',
              url: `/tienda/${encodeURIComponent(code)}/mis-pedidos`,
              noindex: true
            })
          }
          return next()
        }
      } catch (e) {}
      next({ name: 'PageNotFound' })
    }
  },
  {
    path: '/tienda/:client/mis-pedidos/:id',
    name: 'VerPedido',
    component: EstadoPedido,
    beforeEnter: (to, from, next) => {
      console.log('[VerPedido] Route params:', to.params)
      console.log('[VerPedido] Query params:', to.query)
      console.log('[VerPedido] From route:', from.name)
      next()
    }
  },
  {
    path: '/tienda/:client/mesa/:mesaId',
    name: 'MesaQR',
    component: MesaQR,
    beforeEnter: async (to, from, next) => {
      if (!isMobile()) {
        next({ name: 'PageNotFound' })
      }
      const code = to.params.client
      const { Status } = await validateClient(to.params.client)
      if (Status !== 'ok' || Status === 'cerrado') {
        next({ name: 'PageNotFound' })
      }
      store.dispatch('App/setAppLogo', code)
      await store.dispatch('App/setDataClient', code)
      store.dispatch('App/setAppPreviousPage', from.name)
      applyStoreTitleFromState(code)
      next()
    }
  },
  {
    path: '/tienda/:client/mesa/:mesaId/productos',
    name: 'MesaQRProductos',
    component: ProductosMobile,
    beforeEnter (to, from, next) {
      if (!isMobile()) {
        next({ name: 'PageNotFound' })
      }
      next()
    }
  },
  {
    path: '/tienda/:client/checkout/exito',
    name: 'CheckoutExitoso',
    component: MercadoPagoRedirect,
    beforeEnter: async (to, from, next) => {
      console.log('[CheckoutExitoso] Route params:', to.params)
      console.log('[CheckoutExitoso] Query params:', to.query)
      localStorage.setItem('queryMercadoPago', JSON.stringify(to))
      // eslint-disable-next-line
      const { external_reference } = to.query
      console.log('[CheckoutExitoso] External reference:', external_reference)
      console.log('[CheckoutExitoso] Client:', to.params.client)
      // No actualizar el estado aquí, el webhook ya lo hace
      // Solo redirigir a la vista del pedido
      // Manejar el caso donde external_reference puede ser un array
      const pedidoId = Array.isArray(external_reference) ? external_reference[0] : external_reference
      const redirectParams = { client: to.params.client, id: pedidoId }
      console.log('[CheckoutExitoso] Redirecting to VerPedido with params:', redirectParams)
      next({ name: 'VerPedido', params: redirectParams })
    }
  },
  {
    path: '/tienda/:client/checkout/error',
    name: 'CheckoutError',
    component: MercadoPagoRedirect,
    beforeEnter: async (to, from, next) => {
      console.log('[CheckoutError] Route params:', to.params)
      console.log('[CheckoutError] Query params:', to.query)
      localStorage.setItem('queryMercadoPago', JSON.stringify(to))
      // eslint-disable-next-line
      const { external_reference } = to.query
      console.log('[CheckoutError] External reference:', external_reference)
      console.log('[CheckoutError] Client:', to.params.client)
      // No actualizar el estado aquí, el webhook ya lo hace
      // Solo redirigir a la vista del pedido
      // Manejar el caso donde external_reference puede ser un array
      const pedidoId = Array.isArray(external_reference) ? external_reference[0] : external_reference
      const redirectParams = { client: to.params.client, id: pedidoId }
      console.log('[CheckoutError] Redirecting to VerPedido with params:', redirectParams)
      next({ name: 'VerPedido', params: redirectParams })
    }
  },
  {
    path: '/tienda/:client/checkout/pendiente',
    name: 'CheckoutPendiente',
    component: MercadoPagoRedirect,
    beforeEnter (to, from, next) {
      console.log('[CheckoutPendiente] Route params:', to.params)
      console.log('[CheckoutPendiente] Query params:', to.query)
      //  eslint-disable-next-line
      const { external_reference } = to.query
      console.log('[CheckoutPendiente] External reference:', external_reference)
      console.log('[CheckoutPendiente] Client:', to.params.client)
      // Manejar el caso donde external_reference puede ser un array
      const pedidoId = Array.isArray(external_reference) ? external_reference[0] : external_reference
      const redirectParams = { client: to.params.client, id: pedidoId }
      console.log('[CheckoutPendiente] Redirecting to VerPedido with params:', redirectParams)
      next({ name: 'VerPedido', params: redirectParams })
    }
  },
  {
    path: '/tienda/:client/categorias',
    name: 'Categorias',
    component: Categorias,
    beforeEnter (to, from, next) {
      next({ name: 'Home', params: { client: to.params.client } })
    }
  },
  {
    path: '/tienda/:client/productos',
    name: 'ProductosMobile',
    component: ProductosMobile,
    beforeEnter: async (to, from, next) => {
      const code = to.params.client
      try {
        const { Status } = await validateClient(code)
        if (Status === 'ok' || Status === 'cerrado') {
          store.dispatch('App/setAppLogo', code)
          await store.dispatch('App/setDataClient', code)
          store.dispatch('App/setAppPreviousPage', from.name)
          // limpiar cache de productos/categorías al cambiar de tienda
          store.commit('Productos/setProducts', [])
          store.commit('Categorias/setCategoria', null)
          applyStoreTitleFromState(code)
          return next()
        }
      } catch (e) {}
      next({ name: 'PageNotFound' })
    }
  },
  {
    path: '/tienda/:client/productos/:id',
    name: 'Producto',
    component: Producto,
    props: true,
    beforeEnter: async (to, from, next) => {
      const code = to.params.client
      try {
        const { Status } = await validateClient(code)
        if (Status === 'ok' || Status === 'cerrado') {
          store.dispatch('App/setAppLogo', code)
          await store.dispatch('App/setDataClient', code)
          store.dispatch('App/setAppPreviousPage', from.name)
          // asegurar que no queden productos/categorías de otra tienda
          store.commit('Productos/setProducts', [])
          store.commit('Categorias/setCategoria', null)
          // Título definitivo lo setea Producto.vue al cargar el producto
          applyStoreTitleFromState(code)
          return next()
        }
      } catch (e) {}
      next({ name: 'PageNotFound' })
    }
  },
  {
    path: '/tienda/:client/mesa/:mesaId/productos/:id',
    name: 'ProductoQR',
    component: Producto,
    props: true
  },
  {
    path: '/tiendas/cuenta',
    name: 'CuentaGlobal',
    component: Cuenta,
    beforeEnter: async (to, from, next) => {
      store.commit('App/setTiendaActual', null)
      store.commit('App/setData', null)
      store.commit('App/setLogo', null)
      // No limpiar carrito: el usuario vuelve a la misma tienda con "Volver" y espera conservar el pedido.
      applyPageSeo({
        title: 'Mi cuenta - Click Away',
        url: '/tiendas/cuenta',
        noindex: true
      })
      // Cuenta global debe funcionar también en escritorio (no redirigir a sitio marketing).
      next()
    }
  },
  {
    path: '/tiendas/mis-pedidos',
    name: 'MisPedidosGlobal',
    component: MisPedidos,
    beforeEnter: async (to, from, next) => {
      store.commit('App/setTiendaActual', null)
      store.commit('App/setData', null)
      store.commit('App/setLogo', null)
      applyPageSeo({
        title: 'Mis pedidos - Click Away',
        url: '/tiendas/mis-pedidos',
        noindex: true
      })
      next()
    }
  },
  {
    path: '/tiendas',
    name: 'Tiendas',
    component: Tiendas,
    beforeEnter: async (to, from, next) => {
      store.commit('App/setTiendaActual', null)
      store.commit('App/setData', null)
      store.commit('App/setLogo', null)
      store.commit('Carrito/resetItems')
      applyPageSeo({
        title: 'Tiendas - Click Away',
        description: 'Elegí tu tienda y pedí online con Click Away. Delivery y retiro.',
        url: '/tiendas',
        noindex: false
      })
      if (!isMobile()) window.location.href = 'https://info.clickaway.app/'
      next()
    }
  },
  {
    path: '/tienda/:client/checkout',
    name: 'Checkout',
    component: Checkout
  },
  {
    path: '/tienda/:client/cuenta',
    redirect: (to) => ({
      name: 'CuentaGlobal',
      query: {
        from: 'store',
        client: to.params.client,
        home: 'Home'
      }
    })
  },
  {
    path: '/tienda/:client/error',
    name: 'ErrorPage',
    component: ErrorPage
  },
  {
    path: '/sucursales/:id',
    name: 'Sucursales',
    component: Franquicias,
    props: true
  },
  {
    path: '/:client',
    name: 'HomeShort',
    component: Home,
    beforeEnter: async (to, from, next) => {
      // Evitar que coincida con rutas conocidas
      const excludedPaths = ['tiendas', 'sucursales', 'tienda', 'checkout']
      if (excludedPaths.includes(to.params.client)) {
        return next({ name: 'PageNotFound' })
      }
      const code = to.params.client
      try {
        const { Status } = await validateClient(code)
        if (Status === 'ok' || Status === 'cerrado') {
          store.dispatch('App/setAppLogo', code)
          await store.dispatch('App/setDataClient', code)
          store.dispatch('App/setAppPreviousPage', from.name)
          // limpiar cache de productos/categorías al cambiar de tienda
          store.commit('Productos/setProducts', [])
          store.commit('Categorias/setCategoria', null)
          applyStoreTitleFromState(code)
          next()
        } else {
          next({ name: 'PageNotFound' })
        }
      } catch (e) {
        next({ name: 'PageNotFound' })
      }
    }
  },
  {
    path: '*',
    name: 'PageNotFound',
    component: PageNotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.afterEach((to) => {
  // Checkout / cuenta / pedidos: noindex
  if (to.name === 'Checkout') {
    applyPageSeo({
      title: 'Checkout - Click Away',
      url: to.fullPath,
      noindex: true
    })
  }
  // Rutas cortas /:client → canonical ya apunta a /tienda/:client vía applyStoreSeo
})

export default router
